import "./ApplicationOverview.scss";
import React, { useMemo } from "react";
import {
  ApplicationResponse,
  getDetailsLoadingSelector,
} from "@quest-finance/quest-fe-shared/dist/application";
import { LOADING_STATUS } from "@quest-finance/quest-fe-shared/dist/common/constants/loadingStatuses";
import { Col, Row, Form, Spin } from "antd";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { FeatureService } from "../../../feature";
import { workflowActions, useWorkflowDispatch } from "../../../workflow";
import { updateAssessmentDetail } from "../../actions/creators/assessmentDetail";
import { useAssessmentDetailsDispatch } from "../../dispatchers";
import {
  assessmentResponseStatusSelector,
  assessmentResponseSelector,
} from "../../selectors/assessmentDetail";
import { AssessmentDetail } from "../../types/AssessmentDetail";
import AssessmentStatus from "../assessment-status/AssessmentStatus";
import Assignee from "../assignees/Assignees";
import IntroducerDetails from "../introducer-details/IntroducerDetails";
import ApprovalExpiry from "./approval-expiry/ApprovalExpiry";
import LinkedAccounts from "./LinkedAccounts/LinkedAccounts";

type ApplicationOverviewProps = {
  onCheckExistingCustomer?: (application: ApplicationResponse) => void;
};

const ApplicationOverview: React.FunctionComponent<
  ApplicationOverviewProps
> = () => {
  const { assessmentId } = useParams<{
    assessmentId: string;
  }>();
  const assessmentLoadingStatus = useSelector(assessmentResponseStatusSelector);
  const isRetrievingApplication = useSelector(getDetailsLoadingSelector);
  const assessment = useSelector(assessmentResponseSelector);
  const assessmentDetailDispatch = useAssessmentDetailsDispatch();
  const workflowDispatch = useWorkflowDispatch();
  const isWorkflowEnabled = useMemo(() => {
    const isWorkflowEnabled = FeatureService.getConfigValue("workflow");
    return isWorkflowEnabled;
  }, []);

  const onUpdateStatusSuccess = ({
    status,
    statusReason,
    reason,
    settledAt,
  }: Partial<AssessmentDetail>) => {
    assessmentDetailDispatch(
      updateAssessmentDetail({ status, statusReason, reason, settledAt })
    );
    if (isWorkflowEnabled) {
      workflowDispatch(
        workflowActions.getWorkflowSummary({ targetId: assessmentId as string })
      );
    }
  };

  return (
    <div className="application-overview" data-testid="application-overview">
      <Spin
        spinning={
          assessmentLoadingStatus === LOADING_STATUS.LOADING ||
          isRetrievingApplication === true
        }
      >
        <Form layout="vertical">
          <Row gutter={[32, 8]}>
            <Col span={12}>
              <AssessmentStatus
                assessment={assessment}
                onSuccess={onUpdateStatusSuccess}
              />
            </Col>
            <Col span={12}>
              <Assignee
                assessmentId={assessment.id}
                assignees={assessment.assignees}
              />
            </Col>
            <Col span={24} className="">
              <ApprovalExpiry />
            </Col>
            <Col span={12} className="existing-customer">
              <LinkedAccounts />
            </Col>
            <Col span={12}>
              <div className="introducer">
                <IntroducerDetails />
              </div>
            </Col>
          </Row>
          <div className="box-cont">
            <div className="box"></div>
            <div className="box"></div>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default ApplicationOverview;
